module.exports = __webpack_public_path__ + "img/2.3211a099.webp";